import { c as _c } from "react/compiler-runtime";
import { TabColumnDefinitionInterface } from 'modules/funnels/funnel/components/tab-table';
import { FunnelStepStatTableInterface, SplitTestHistoryTableInterface } from 'modules/funnels/funnel/types/funnel-tests-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { dateFormat } from 'shared/utils/date-time-format';
import type { JSX } from "react";
interface useSplitTestTableColumnsProps {
  trashIconRenderer?: (data: SplitTestHistoryTableInterface) => JSX.Element;
  withEndDate?: boolean;
}
export const useSplitTestTableColumns = t0 => {
  const $ = _c(33);
  const {
    trashIconRenderer,
    withEndDate
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  let t1;
  if ($[0] !== trashIconRenderer || $[1] !== user?.dateFormat || $[2] !== user?.timezone || $[3] !== withEndDate) {
    t1 = data => <>{data && <div className="flex items-center"><span>{data.splitTest.startedAt && `${dateFormat(data.splitTest.startedAt, {
            dateFormat: user?.dateFormat,
            timeZone: user?.timezone
          })} -`}</span>{withEndDate && <span>{data.splitTest.finishedAt && `${dateFormat(data.splitTest.finishedAt, {
            dateFormat: user?.dateFormat,
            timeZone: user?.timezone
          })}`}</span>}{trashIconRenderer && trashIconRenderer(data)}</div>}</>;
    $[0] = trashIconRenderer;
    $[1] = user?.dateFormat;
    $[2] = user?.timezone;
    $[3] = withEndDate;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [{
      widthPercent: 100,
      title: " ",
      onRender: _temp
    }];
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1) {
    t3 = {
      key: "funnelStepName",
      header: " ",
      onHeaderRender: t1,
      widthPercent: 30,
      subHeaders: t2
    };
    $[6] = t1;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("dashboard.funnel.statistics.page_views");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [{
      widthPercent: 100,
      title: " ",
      onRender: _temp2
    }];
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4) {
    t6 = {
      key: "pageViewsUnique",
      header: t4,
      widthPercent: 30,
      subHeaders: t5
    };
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("dashboard.funnel.split_tests.conversions");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t("dashboard.funnel.statistics.all");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = {
      widthPercent: 30,
      title: t8,
      onRender: _temp3
    };
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t("dashboard.funnel.statistics.conversion_rate");
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10) {
    t11 = {
      widthPercent: 70,
      title: t10,
      onRender: _temp4
    };
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t9) {
    t12 = [t9, t11];
    $[23] = t11;
    $[24] = t9;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t7) {
    t13 = {
      key: "optIns",
      header: t7,
      widthPercent: 20,
      subHeaders: t12
    };
    $[26] = t12;
    $[27] = t7;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t13 || $[30] !== t3 || $[31] !== t6) {
    t14 = [t3, t6, t13];
    $[29] = t13;
    $[30] = t3;
    $[31] = t6;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  return t14;
};
function _temp(funnelStep) {
  return <span className="truncate font-normal">{funnelStep.funnelStepName}</span>;
}
function _temp2(funnelStep_0) {
  return <span className="truncate font-normal">{funnelStep_0.pageViewsUnique}</span>;
}
function _temp3(funnelStep_1) {
  return <span className="truncate font-normal">{funnelStep_1.conversionAll}</span>;
}
function _temp4(funnelStep_2) {
  return <span className="truncate font-normal">{funnelStep_2.conversionRate}</span>;
}